import React from "react"

const LogoSvg = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			width={"679"}
			height={"482"}
			viewBox={"0 0 679 482"}
			fill={"none"}
			{...props}
		>
			<path
				d={
					"M113.102 254.675V367.863L0 254.675V0H452.361L565.462 113.189H113.102V254.675ZM565.462 113.189V367.863H113.102L226.204 481.052H678.565V226.377L565.462 113.189Z"
				}
				fill={"white"}
				fill-opacity={"0.2"}
			/>
		</svg>
	)
}

export default LogoSvg
